import React from "react";
import { Typewriter } from "react-simple-typewriter";
import { GrLinkedin } from "react-icons/gr";
import { BsFacebook, BsGithub } from "react-icons/bs";


const Hero = () => {
  return (
    <div>
      <section className=" text-gray-100">
        <div className="container flex flex-col justify-center p-6 mx-auto sm:py-12 lg:py-24 lg:flex-row lg:justify-between">
          <div
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
            className="flex flex-col justify-center p-6 text-center rounded-sm lg:max-w-md xl:max-w-2xl lg:text-left"
          >
            <h1 className="text-5xl  leading-none sm:text-6xl">
              Hello Iam
              <br />
              <span className="text-blue-400"> Rohit mondal</span>
            </h1>
            <p className="mt-6 text-xl">
              <span> I'm a </span>
              <Typewriter
                words={[
                  "Web Designer !",
                  "Web Devloper !",
                  "Web Fornt-end Devloper !",
                  "Learner !",
                ]}
                loop={true}
                cursor
                cursorStyle="_"
                typeSpeed={80}
                deleteSpeed={50}
                delaySpeed={1000}
              />
            </p>

            <p className="mt-6 mb-6 text-lg sm:mb-12">
              I am a front end web developer and new technology lover.
              {/* <br className="hidden md:inline lg:hidden"></br>turpis pulvinar,
              est scelerisque ligula sem */}
            </p>
            <div
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500"
              className="flex gap-4 text-3xl mb-6 justify-center lg:justify-start"
            >
              <a
                className="hover:bg-blue-500 hover:shadow-lg hover:shadow-blue-500/50"
                href="https://www.linkedin.com/in/rohitmondal1/"
                target="blank"
              >
                <GrLinkedin />
              </a>
              <a
                className="hover:bg-blue-500 hover:shadow-lg hover:shadow-blue-500/50"
                href="https://github.com/rohit-mondal1"
                target="blank"
              >
                <BsGithub />
              </a>
              <a
                className="hover:bg-blue-500 hover:shadow-lg hover:shadow-blue-500/50"
                href="https://www.facebook.com/rahulsarker.rahulsarker.526/"
                target="blank"
              >
                <BsFacebook />
              </a>
            </div>
            <div className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">
              <a
                data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="1500"
                target="blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/in/rohitmondal1/"
                className="px-8 py-3 text-lg font-semibold rounded bg-blue-400 text-gray-900"
              >
                Hire Me
              </a>

              <a
                data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="1500"
                href="https://drive.google.com/uc?export=download&id=1zuR54VEdeoPaH7otqDtUo1-lhpNGTRRT"
                download
                className="px-8 py-3 text-lg font-semibold border rounded border-gray-100"
              >
                Downlode Resume
              </a>
            </div>
          </div>

          <div
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
            className="flex items-center justify-center p-6 mt-8 lg:mt-0 h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128"
          >
            <div className="avatar">
              <div className="max-w-xl  mask mask-squircle">
                <img
                  src="https://i.ibb.co/H4X6SDV/IMG20230314164326-removebg.png"
                  alt="Rahul sarker"
                  className="  shadow-2xl"
                />
              </div>
            </div>
            {/* <div className="avatar ">
              <div className="max-w-lg mask mask-hexagon">
                <img
                  src="https://i.ibb.co/gFJv93D/IMG20221202201607.jpg"
                  alt="Rahul sarker"
                  className="max-w-sm  rounded-full shadow-2xl"
                />
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hero;
